import React from "react";

/** Catches uncaught render errors so the entire app doesn't blank-screen. */
export default class ErrorBoundary extends React.Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("ErrorBoundary caught:", error, info);
    }

    reset = () => this.setState({ error: null });

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <div className="min-h-[60vh] grid place-items-center p-8">
                <div className="card-base p-8 max-w-lg text-center" data-testid="error-boundary">
                    <div className="label-micro text-red-400 mb-2">Something broke</div>
                    <div className="font-display text-2xl mb-3">A page crashed.</div>
                    <p className="text-sm text-zinc-400 mb-4">
                        {String(this.state.error?.message || this.state.error || "Unknown error")}
                    </p>
                    <div className="flex gap-2 justify-center">
                        <button onClick={this.reset} className="btn-secondary">Try again</button>
                        <button onClick={() => (window.location.href = "/dashboard")} className="btn-primary">
                            Back to dashboard
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
